import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionMenuComponent } from './permission-menu.component';
import { PermissionMenuContentComponent } from './permission-menu-content.component';
import { MMIconsModule, TooltipModule, MmToastModule, AlertModule } from 'mm-ui';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ViewService } from '../../../view/view.service';
import { AccessProfileService } from '../../../access-profile/access-profile.service';
import { MediaService } from '../../../media/media.service';
import { TranslateModule } from '@ngx-translate/core';
import { FloatMenuComponent } from 'projects/f-cms/src/app/shared/float-menu/float-menu.component';

@NgModule({
  declarations: [PermissionMenuComponent],
  exports: [PermissionMenuComponent],
  imports: [
    CommonModule,
    MMIconsModule,
    TooltipModule,
    MmToastModule,
    AlertModule,
    NgScrollbarModule,
    TranslateModule,
    FloatMenuComponent,
    PermissionMenuContentComponent
  ],
  providers: [ViewService, AccessProfileService, MediaService]
})
export class PermissionMenuModule { }
